export default function buildLeadSessionId(): string {
  return crypto.randomUUID();
}
